import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
import { AppComponent } from 'src/app/app.component';
declare var $;
import { NavService } from 'src/app/_services/nav.service';
import {
  SortColumn,
  SortDirection,
  SortEvent,
  NgbdSortableHeader,
} from '../irm/sortable.directive';
import { SortService } from 'src/app/_services/sort.service';
import { DlpReportService } from 'src/app/_services/dlpReport.service';
import { pickBy, identity } from 'lodash';
import { CompanyService } from 'src/app/_services/company.service';
import { IrmReportService } from 'src/app/_services/irmReport.service';
import { ToastrService } from 'src/app/_services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PopupSensitiveInformationType } from './popup-sensitive-infomation-types/popup-sensitive-infomation-types.component';
import { DatePeriodService } from 'src/app/_services/date-period.service';
import { PopupLimiteRegistrosComponent } from '../components/popup-limite-registros/popup-limite-registros.component';
interface Report {
  date: string;
  action: string;
  user: string;
  departament: string;
  label: string;
  priority: string;
  elem: number;
  opc: string;
}

@Component({
  selector: 'app-informes-dlp',
  templateUrl: './informes-dlp.component.html',
  styleUrls: ['./informes-dlp.component.css'],
})
export class InformesDLPComponent implements OnInit, AfterViewInit {
  data: { title: 'Informes' };
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  user: string;
  selectedActions: any[] = [];
  selectedDeptos: any[] = [];
  selectedPriorities: any[] = [];
  minDate: any;
  maxDate: any;
  prueba: any;
  sortState: any;
  REPORTS: Report[] = [];
  reports: any = [];
  page = 1;
  pageSize = 10;
  collectionSize = 0;
  isCountLoading = false;
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  areFiltersCollapsed = true;
  isLoading: boolean = true;
  filters: any;
  actions: any[] = [];
  labels: any[] = [];
  labelsName: any[] = [];
  departments: any[] = [];
  selectedLabels: any[] = [];
  priorities: any[] = [];
  maxLength: number = 30;
  todasLasOpciones: [] = [];
  trueExternalDelivery: boolean = false;
  falseExternalDelivery: boolean = false;
  trueInfoLeak: boolean = false;
  falseInfoLeak: boolean = false;
  savedSortStr: any;
  protected ngbModalRef: NgbModalRef;

  // tslint:disable-next-line: max-line-length
  constructor(
    private appComponent: AppComponent,
    private navService: NavService,
    public sortService: SortService,
    public dlpReportService: DlpReportService,
    private toastrService: ToastrService,
    public companyService: CompanyService,
    public irmReportService: IrmReportService,
    private translate: TranslateService,
    private dataPeriodService: DatePeriodService,
    private modalService: NgbModal
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    this.isLoading = true;
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);

    const quickCategoryDashboardEvent = window.sessionStorage.getItem(
      'quickCategoryDashboardEvent'
    );
    const filterForExternalDelivery = window.sessionStorage.getItem(
      'filterForExternalDelivery'
    );
    const filterForInfoLeak = window.sessionStorage.getItem(
      'informationLeakEvent'
    );

    if (quickCategoryDashboardEvent) {
      if (filterForExternalDelivery) {
        this.trueExternalDelivery = true;
        this.areFiltersCollapsed = false;
        window.sessionStorage.removeItem('filterForExternalDelivery');
      }

      if (filterForInfoLeak) {
        this.trueInfoLeak = true;
        this.areFiltersCollapsed = false;
        window.sessionStorage.removeItem('informationLeakEvent');
      }

      const date = this.dataPeriodService.getDate();
      this.minDate = date?.start;
      this.maxDate = date?.end;
      window.sessionStorage.removeItem('quickCategoryDashboardEvent');
    } else {
      const savedFiltersStr =
        window.sessionStorage.getItem('informesDlpFilters');
      const savedSortStrItem = window.sessionStorage.getItem('informesDlpSort');
      if (savedSortStrItem) {
        this.savedSortStr = JSON.parse(savedSortStrItem);
      }

      if (savedFiltersStr) {
        const savedFilters = JSON.parse(savedFiltersStr);
        this.user = savedFilters.user;
        this.selectedActions = savedFilters.selectedActions;
        this.selectedDeptos = savedFilters.selectedDeptos;
        this.selectedPriorities = savedFilters.selectedPriorities;
        this.minDate = savedFilters.minDate
          ? new Date(savedFilters.minDate)
          : this.minDate;
        this.maxDate = savedFilters.maxDate
          ? new Date(savedFilters.maxDate)
          : this.maxDate;
        this.trueExternalDelivery = savedFilters.trueExternalDelivery;
        this.falseExternalDelivery = savedFilters.falseExternalDelivery;
        this.trueInfoLeak = savedFilters.trueInfoLeak;
        this.falseInfoLeak = savedFilters.falseInfoLeak;
        this.sortState = savedFilters.sortState;
        this.sortColumn = savedFilters.sortColumn;
        this.sortDirection = savedFilters.sortDirection;

        if (
          this.user ||
          (this.selectedActions?.length ?? 0) > 0 ||
          (this.selectedDeptos?.length ?? 0) > 0 ||
          (this.selectedPriorities?.length ?? 0) > 0 ||
          this.trueExternalDelivery ||
          this.falseExternalDelivery ||
          this.trueInfoLeak ||
          this.falseInfoLeak
        ) {
          this.areFiltersCollapsed = false;
        } else {
          this.areFiltersCollapsed = true;
        }
      }
    }

    this.setFilters();
    this.getActions();
    this.getDepartments();
    this.getPolicies();

    this.selectedNavItem({
      parent: 'record.report',
      child: 'record.dpo',
      description: 'pageDescriptions.dlp',
    });
  }

  ngAfterViewInit() {
    this.restoreSort();
    this.headers.changes.subscribe(() => {
      this.restoreSort();
    });
  }

  restoreSort() {
    if (this.sortColumn && this.sortDirection) {
      setTimeout(() => {
        const activeHeader = this.headers?.find(
          (h) => h.sortable === this.sortColumn
        );
        if (activeHeader) {
          activeHeader.direction = this.sortDirection;
        }
      });
    }
  }

  formatDate(selectedDate: Date): string {
    const day = selectedDate.getDate().toString().padStart(2, '0');
    const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = selectedDate.getFullYear().toString().substring(2);

    return `${day}.${month}.${year}`;
  }

  saveFiltersToSession() {
    const filtersToSave = {
      user: this.user,
      selectedActions: this.selectedActions,
      selectedDeptos: this.selectedDeptos,
      selectedPriorities: this.selectedPriorities,
      minDate: this.minDate,
      maxDate: this.maxDate,
      trueExternalDelivery: this.trueExternalDelivery,
      falseExternalDelivery: this.falseExternalDelivery,
      trueInfoLeak: this.trueInfoLeak,
      falseInfoLeak: this.falseInfoLeak,
      sortState: this.sortState,
      sortColumn: this.sortColumn,
      sortDirection: this.sortDirection,
    };
    window.sessionStorage.setItem(
      'informesDlpFilters',
      JSON.stringify(filtersToSave)
    );
  }

  setFilters() {
    const filters = {
      mail: this.user,
      type:
        this.selectedActions?.length > 1
          ? [this.selectedActions]
          : this.selectedActions,
      department:
        this.selectedDeptos?.length > 1
          ? [this.selectedDeptos]
          : this.selectedDeptos,
      policy:
        this.selectedPriorities?.length > 1
          ? [this.selectedPriorities]
          : this.selectedPriorities,
      dateBegin: this.minDate && this.formatDate(this.minDate),
      dateEnd: this.maxDate && this.formatDate(this.maxDate),
      externalDelivery:
        this.trueExternalDelivery === this.falseExternalDelivery
          ? undefined
          : this.trueExternalDelivery,
      infoLeak:
        this.trueInfoLeak === this.falseInfoLeak
          ? undefined
          : this.trueInfoLeak,
    };

    this.filters = {
      ...filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };

    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.saveFiltersToSession();
    this.refreshReports(true);
  }

  cleanFilters() {
    const today = new Date();
    this.maxDate = today;
    this.minDate = new Date(today);
    this.minDate.setDate(this.minDate.getDate() - 7);
    this.user = undefined;
    this.selectedActions = undefined;
    this.selectedDeptos = undefined;
    this.selectedPriorities = undefined;
    this.trueExternalDelivery = false;
    this.falseExternalDelivery = false;
    this.trueInfoLeak = false;
    this.falseInfoLeak = false;
    this.filters = undefined;
    this.sortState = undefined;
    this.sortColumn = undefined;
    this.sortDirection = undefined;
    this.filters = {
      ...this.filters,
      sort: this.sortState?.sort,
      order: this.sortState?.order,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.saveFiltersToSession();
    this.refreshReports(true);
  }

  refreshReports(refetchCount: boolean = false) {
    this.isLoading = true;

    if (refetchCount) {
      this.isCountLoading = true;
      this.collectionSize = 0;
    }

    this.dlpReportService
      .getAllDlpReports(this.page, this.pageSize, this.filters)
      .subscribe((res) => {
        this.reports = res.body['results'];
        const embeddedTotal = res.body['total'];
        if (embeddedTotal > 0) {
          this.collectionSize = embeddedTotal;
          this.isCountLoading = false;
        } else if (this.isCountLoading) {
          // Count still loading: estimate collectionSize so user can paginate now
          const viewed = (this.page - 1) * this.pageSize + this.reports.length;
          const optimistic = this.reports.length === this.pageSize ? viewed + this.pageSize : viewed;
          if (optimistic > this.collectionSize) {
            this.collectionSize = optimistic;
          }
        }
        this.isLoading = false;
      });

    if (refetchCount) {
      this.dlpReportService
        .getDlpAlertsCount(this.filters)
        .subscribe({
          next: (res) => {
            this.collectionSize = res.body['total'];
            this.isCountLoading = false;
          },
          error: () => {
            this.isCountLoading = false;
          },
        });
    }
  }

  getDepartments() {
    this.companyService.getDepartments().subscribe((res) => {
      this.todasLasOpciones = res.body;
      this.departments = this.todasLasOpciones.slice(0, 20);
    });
  }

  getPolicies() {
    this.dlpReportService.getPolicies().subscribe((res) => {
      this.priorities = res?.body;
    });
  }

  cargarMasOpciones() {
    // Carga más opciones a 'opcionesPaginadas' al hacer scroll o al presionar un botón
    const inicio = this.departments.length;
    const fin = inicio + 20;
    this.departments = this.departments.concat(
      this.todasLasOpciones.slice(inicio, fin)
    );
  }

  getActions() {
    this.dlpReportService.getTypes().subscribe((res) => {
      this.actions = res.body;
    });
  }

  generateGeneralIrmReport() {
    const total = this.collectionSize;
    if (total > 500000) {
      this.ngbModalRef = this.modalService.open(PopupLimiteRegistrosComponent, { size: 'lg', backdrop: 'static' });
      this.ngbModalRef.componentInstance.cantidadRegistros = total;
      this.ngbModalRef.result.then((result) => { if (result === 'continuar') this.reqIrmReport(); });
    } else {
      this.reqIrmReport();
    }
  }

  reqIrmReport() {
    let filters = { ...this.filters };
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.dlpReportService.generateGeneralDlpReport(filters, this.translate.currentLang)
      .subscribe((res) => {}, (error) => { this.toastrService.error(this.translate.instant('errorReport')); });
  }

  generateEvoDlpReport() {
    const total = this.collectionSize;
    if (total > 500000) {
      this.ngbModalRef = this.modalService.open(PopupLimiteRegistrosComponent, { size: 'lg', backdrop: 'static' });
      this.ngbModalRef.componentInstance.cantidadRegistros = total;
      this.ngbModalRef.result.then((result) => { if (result === 'continuar') this.reqEvoIrmReport(); });
    } else {
      this.reqEvoIrmReport();
    }
  }

  reqEvoIrmReport() {
    let filters = { ...this.filters };
    this.toastrService.info(this.translate.instant('onProcessGeneratngReport'));
    this.dlpReportService.generateEvoDlpReport(filters, this.translate.currentLang)
      .subscribe((res) => {}, (error) => { this.toastrService.error(this.translate.instant('errorReport')); });
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.sortColumn = column;
    this.sortDirection = direction;

    if (this.sortDirection !== '') {
      this.filters = {
        ...this.filters,
        sort: this.sortColumn,
        order: this.sortDirection,
      };
      this.sortState = {
        sort: this.sortColumn,
        order: this.sortDirection,
      };
    } else {
      delete this.filters.sort;
      delete this.filters.order;
      this.sortState = undefined;
    }
    this.saveFiltersToSession();
    this.refreshReports();
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }

  seeSensitiveData(sensitiveInformationTypes: any[]) {
    this.ngbModalRef = this.modalService.open(PopupSensitiveInformationType, {
      backdrop: 'static',
      centered: true,
      windowClass: 'modal-holder',
      size: 'lg',
    });
    this.ngbModalRef.componentInstance.sensitiveInformationTypes =
      sensitiveInformationTypes;

    this.ngbModalRef.result.then();
  }
}
